var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmokeLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 170,
    viewBox: "0 0 437 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.9955 51.2449C71.0087 54.4186 48.7 59.179 39.0439 61.1626C34.3824 74.2208 26.0582 105.99 30.0538 128.602C35.0483 156.868 50.5313 128.602 70.5093 121.66C90.4873 114.718 119.955 121.66 140.932 121.66H199.367C224.839 121.66 257.803 128.602 297.759 133.561C337.715 138.52 353.198 135.049 381.167 128.602C409.136 122.156 403.143 113.726 407.638 100.337C411.234 89.6261 387.16 88.9319 374.674 89.9236C365.851 89.0972 348.004 86.2541 347.204 81.4936C346.206 75.5431 367.682 67.1131 390.157 51.2449C408.137 38.5504 400.979 38.352 395.152 39.8396L374.674 29.922C359.524 30.7485 328.026 33.8891 323.231 39.8396C317.237 47.2779 307.748 61.1626 297.759 61.1626C287.77 61.1626 264.795 67.1131 244.817 67.1131H224.839C233.163 61.8237 250.311 51.2449 252.309 51.2449C254.806 51.2449 239.823 43.3108 224.839 39.8396C209.856 36.3685 200.866 46.2861 194.373 51.2449C187.88 56.2038 173.895 77.5266 151.42 76.039C133.44 74.8489 136.936 65.6255 140.932 61.1626C126.614 56.5343 94.9823 48.0713 82.9955 51.2449Z",
    fill: "url(#paint0_linear_1_990)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_990",
    x: 0,
    y: 0.921997,
    width: 437,
    height: 169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5,
    result: "effect1_foregroundBlur_1_990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_990",
    x1: 218.5,
    y1: 29.922,
    x2: 218.5,
    y2: 140.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#368BAF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeLeft);
export default __webpack_public_path__ + "static/media/smoke-left.5c09c27c2914d8087e911d5ec680165e.svg";
export { ForwardRef as ReactComponent };